/* ============
 * Claim Transformer
 * ============
 *
 * The transformer for the claim data.
 */

import Transformer from './Transformer'

const moment = require('moment')

export default class ClaimTransformer extends Transformer {
  /**
   * Method used to transform a fetched claim.
   *
   * @param claim The fetched claim.
   *
   * @returns {Object} The transformed claim.
   */
  static fetch (claim) {
    return {
      offerId: claim['deal_id'],
      offerTitle: claim['deal_title'],
      date: moment(claim['first_claim_iso']).format('YYYY-MM-DD HH:mm'),
      redeemExpiresTimeISO: claim['redeem_expires_time'],
      redeemExpiresTime: moment(claim['redeem_expires_time']).format('YYYY-MM-DD HH:mm')
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/ClaimTransformer.js